<template>

<v-dialog v-model="dialog" width="600px">
  <v-card>
    <v-card-title class="text-h5 grey lighten-2">Add New Listing promo to {{hnlp.huis_code }} </v-card-title>
    <v-card-text>
      <v-form ref="addHnlp" v-model="addHnlpValid">
        <v-row>
          <v-col cols="12">
            <v-select v-model="hnlp_inpt_code" :rules="hnlp_inpt_codeRules" required :items="inpt_codeKeuzes" item-value="inpt_code" item-text="inpt_oms" label="Partner"></v-select>
          </v-col>
        </v-row>  
        <v-row>
          <v-col cols="6" class="pa-2">
            <date_picker label="Discount Start date"                                 
                                     :date="hnlp_start_dat"
                                     :startDate="hnlp_start_dat"
                                     field="hnlp_start_dat" 
                                     hint="" 
                                     icon="mdi-calendar-month-outline"
                                     :manual="true"
                                     required
                                     :rules="hnlp_start_datRules"
                                     @updateData="updateData"/> 
          </v-col>
          <v-col cols="6" class="pa-2">
            <v-select
              v-model="hnlp_aant_boek"
              :items="hnlp_aant_boekOptions"
              label="Max. bookings"
              dense
              hide-details="auto"
              required
            ></v-select>
          </v-col>
        </v-row>    
        <v-row>
          <v-col cols="6">
            <v-text-field v-model="hnlp_klnt_perc" :rules="hnlp_klnt_percRules" required label="Discount % customer"></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field v-model="hnlp_eign_perc" :rules="hnlp_eign_percRules" required label="Discount % owner"></v-text-field> 
          </v-col>
        </v-row>    

      </v-form>
      <v-alert
      dense
      outlined
      type="error"
      v-if="error.length > 0"
    >
      {{ error }}
    </v-alert>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="primary mx-2" small @click="addHnlp" :disabled="!addHnlpValid">Save</v-btn>
      <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>

import date_picker from '@/components/ui/date_picker.vue';

export default {
  data() { 
    return {
      dialog: false,
      addHnlpValid: false,
      error: "",
      huis_encrid: null,
      inpt_codeKeuzes: [],
      hnlp: {},
      hnlp_klnt_perc: "",
      hnlp_aant_boek: 3,
      hnlp_aant_boekOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      hnlp_klnt_percRules: [
        v => !!v || 'Discount % Customer is required',
      ],
      hnlp_eign_perc: "",
      hnlp_eign_percRules: [
        v => !!v || 'Discount % Owner is required',
      ],
      hnlp_start_dat: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      hnlp_start_datRules: [
        v => !!v || 'Start date is required',
      ],
      hnlp_inpt_code: "",
      hnlp_inpt_codeRules: [
        v => !!v || 'Partner is required',
      ],
    }
  },
  components: {
    date_picker,
  },
  methods: {
    open(huis_encrid) {
      this.addHnlpValid = false;
      this.error = "";
      this.hnlp_eign_perc = "10";
      this.hnlp_klnt_perc = "20";
      this.hnlp_start_dat = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
      this.hnlp_inpt_code = "";
      this.hnlp_aant_boek = 3;
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/huis/hnlp/getHuisToAddHnlp.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHuisToAddHnlp"
          },
          getHuisToAddHnlp: {
            huis_encrid: huis_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.hnlp = res.data.getHuisToAddHnlp;
            this.inpt_codeKeuzes = res.data.getHuisToAddHnlp.inpt_codeKeuzes;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updateData(data){
      //console.log('updateData', data);
      this[data.field] = data.value;
    },
    addHnlp() { 
      console.log('max. aantal boekingen', this.hnlp_aant_boek)
      this.$axios
        .post("ares/json/ares/huis/hnlp/addHuisHnlp.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "addHuisHnlp"
          },
          addHuisHnlp: {
            huis_encrid: this.hnlp.huis_encrid,
            hnlp_inpt_code: this.hnlp_inpt_code,
            hnlp_klnt_perc: this.hnlp_klnt_perc,
            hnlp_eign_perc: this.hnlp_eign_perc,
            hnlp_start_dat: this.hnlp_start_dat,
            hnlp_aant_boek: this.hnlp_aant_boek
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
            this.error = res.data.error.message;
          }  else { 
            if (res.data.addHuisHnlp.color == "success")        
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.addHuisHnlp.text,
              color: res.data.addHuisHnlp.color
            }); 
            this.dialog = false;
            this.$parent.getOverview();
          }
        })
    }
  }
}
</script>

